var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMgLiraLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 644.81 218.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#503181;}.cls-2{fill:#0fceae;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.06,128.56a13,13,0,0,1-7.89-2.68A54,54,0,1,1,108,83a13,13,0,1,1-26,0,28,28,0,1,0-45,22.25,13,13,0,0,1-7.91,23.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.05,130a12.91,12.91,0,0,1-7.26-2.23A54,54,0,1,1,190,83a13,13,0,0,1-26,0,28,28,0,1,0-43.66,23.23A13,13,0,0,1,113.05,130Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.09,130a13,13,0,0,1-7.25-2.22A54,54,0,1,1,272,83a13,13,0,0,1-26,0,28,28,0,1,0-43.63,23.25A13,13,0,0,1,195.09,130Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.08,124c.73-.63,1.46-1.28,2.17-2A53.68,53.68,0,0,0,354,84.27a13,13,0,0,0-26-.61A28,28,0,1,1,300,55h1a13,13,0,0,0,.3-26,54,54,0,1,0-2.53,108l1.26,0h0a28,28,0,1,1-28,28,13,13,0,0,0-26,0,54,54,0,1,0,89.08-41Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 369.99,
    cy: 118.05,
    r: 11.98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.22,13.43a13.43,13.43,0,1,1,26.85,0V117.66a13.43,13.43,0,1,1-26.85,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.94,50.18a13.44,13.44,0,0,1,26.86,0v67.88a13.44,13.44,0,0,1-26.86,0ZM471.8,13.43A13.43,13.43,0,1,1,458.37,0,13.42,13.42,0,0,1,471.8,13.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M494.11,47.7a13.43,13.43,0,1,1,26.85,0v4.24c3.88-9.19,10.24-17.67,18.19-17.67,8.31,0,13.08,5.48,13.08,13.08,0,7.06-4.6,11.3-10.07,12.54C528.55,63.07,521,73.49,521,92.57v25.09a13.43,13.43,0,1,1-26.85,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M557.45,102.82v-.35c0-20.67,15.73-30.21,38.16-30.21a67.53,67.53,0,0,1,23.15,3.88V74.55c0-11.13-6.89-17.31-20.32-17.31a61.57,61.57,0,0,0-18.55,2.65,11.37,11.37,0,0,1-3.89.71,10.94,10.94,0,0,1-11.13-11,11.13,11.13,0,0,1,7.25-10.42c8.48-3.18,17.66-4.95,30.21-4.95,14.66,0,25.26,3.89,32,10.6,7.07,7.07,10.25,17.49,10.25,30.21v43.11a12.9,12.9,0,0,1-13.07,12.9c-7.78,0-12.9-5.48-12.9-11.13v-.18c-6.54,7.24-15.55,12-28.62,12C572.12,131.79,557.45,121.55,557.45,102.82Zm61.66-6.18V91.87A41.63,41.63,0,0,0,602,88.33c-11.48,0-18.55,4.6-18.55,13.08v.35c0,7.24,6,11.48,14.67,11.48C610.63,113.24,619.11,106.35,619.11,96.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMgLiraLogoColor);
export default __webpack_public_path__ + "static/media/mg-lira-logo-color.11721322ff5412f92bc9ee3deb92025a.svg";
export { ForwardRef as ReactComponent };